import {formatISOByGuard} from '@shared/helpers/date'

import {initDeliveryTracking} from '@web/slices/deliveryTracking/slice'
import makeSlice from '@web/slices/recommendationProduct/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDeliveryTracking.fulfilled, (state, {payload}) => {
            const orderDelivery = payload.orderDelivery

            if (orderDelivery) {
                const product = orderDelivery.productOrder
                const productCategoryId =
                    product.detailCategoryId ??
                    product.smallCategoryId ??
                    product.middleCategoryId ??
                    product.largeCategoryId ??
                    undefined

                state.products = [
                    {
                        ecNvMid: product.ecNvMid ?? undefined,
                        orderDateTime: formatISOByGuard(orderDelivery.orderDateTime) ?? undefined,
                        productOrderStatus: product.productOrderStatusType ?? undefined,
                        productPaymentAmount: product.orderAmount ?? undefined,
                        productCategoryId,
                    },
                ]
            }
        })
    },
})

export default slice.reducer
